module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom-router",
    style: ({
      paddingBottom: _vm.iPhoneX ? '12px' : '0'
    })
  }, [_c('div', {
    staticClass: "bottomRouter-main"
  }, [_c('div', {
    staticClass: "bottomRouter-main-item",
    on: {
      "click": function($event) {
        return _vm.changePage('index')
      }
    }
  }, [_c('div', [(_vm.page == 'index') ? _c('img', {
    attrs: {
      "src": require("../../assets/img/common/index-active.svg"),
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/img/common/index-default.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    class: [_vm.page == 'index' ? 'active' : '']
  }, [_vm._v("首页")])]), _vm._v(" "), _c('div', {
    staticClass: "bottomRouter-main-item",
    on: {
      "click": function($event) {
        return _vm.changePage('ade')
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("有赚")])]), _vm._v(" "), _c('div', {
    staticClass: "bottomRouter-main-item",
    on: {
      "click": function($event) {
        return _vm.changePage('user')
      }
    }
  }, [_c('div', [(_vm.page == 'user') ? _c('img', {
    attrs: {
      "src": require("../../assets/img/common/user-active.svg"),
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/img/common/user-default.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    class: [_vm.page == 'user' ? 'active' : '']
  }, [_vm._v("\n        我的\n      ")]), _vm._v(" "), (_vm.noticeprompt) ? _c('div', {
    staticClass: "noticetips",
    style: (_vm.promptstyle)
  }, [_vm._v(_vm._s(_vm.noticecount))]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/img/common/ade-default.svg"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-150c9286","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/bottomRouter.vue
// module id = 236
// module chunks = 45